module.exports = __webpack_public_path__ + "img/camion1.860a1428.jpg";